import React, {useState, useEffect} from 'react'
import NavItem from './NavItem';
import DropdownMenu from './DropdownMenu';
import { ReactComponent as MessengerIcon } from '../icons/messenger.svg';
import { ReactComponent as CaretIcon } from '../icons/caret.svg';
import { ReactComponent as PlusIcon } from '../icons/plus.svg';
import Typewriter from "typewriter-effect";

import TextLoop from 'react-text-loop'

const Navbar = (props) => {
    const [labelText, setLabelText] = useState("Attention: ");
    const [textLoopClass, setTextLoopClass] = useState("text-loop-off")
    const [typewriterClass, setTypewriterClass] = useState("typewriter-on")

    return (
        <nav className="navbar">
            <h2 className="nav-message">
            <div  className={typewriterClass}>
                <Typewriter
                    options={{
                        autoStart: true,
                        loop: false,
                        delay: 75,
                    }}
                    onInit={(typewriter)=> {
                    typewriter
                    .pauseFor(1000)
                    .typeString(labelText) 
                    //.deleteChars(10)
                    .pauseFor(1000)
                    .callFunction(() =>{
                        //setLabelText("")
                        setTextLoopClass("text-loop-on")
                        setTypewriterClass("typewriter-off")
                    })
                    .start();
                    }}
                >
                </Typewriter>
            </div>
            <div className={textLoopClass}>
            {labelText}
            <TextLoop>
                <span className='nav-message-scroll-text'>&nbsp;For assistance: email LPASIntakes@nasboces.org</span>
                <span className='nav-message-scroll-text'>&nbsp;For assistance: email LPASIntakes@nasboces.org</span>
            </TextLoop>
            </div>
                
            </h2>
            <ul className="navbar-nav">{props.children}
                {/*
                <NavItem icon={<PlusIcon/>} link={props.homeUrl}/>
                <NavItem icon={<MessengerIcon/>} link="mailto:lpasintakes@nasboces.org?subject=Intakes"/>
                */}
                <NavItem icon={<CaretIcon/>}>
                    <DropdownMenu changeTabState={props.changeTabState} handleLogout={props.handleLogout}/>
                </NavItem>
            </ul>
            
        </nav>
    )
}

export default Navbar
